<template>
   <div class="mt-[4rem]  pb-[2.1rem]  ">
      <div class="pt-[2.188rem]">
         <div v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN">
            <div class="bg-white rounded-lg shadow p-4">
               <div class="flex items-center justify-between mb-3">
                  <h3 class="text-lg font-semibold">{{ t('dashboardOverview') || 'Overview' }}</h3>
               </div>
               <div class="w-full grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <MoleculeStatBrick :title="`${t('totalCountries')}:`" :value="stats.countries" icon="pi pi-globe"
                     iconBg="bg-blue-500" iconColor="text-white" cardBg="bg-white" valueClass="text-gray-900" />
                  <MoleculeStatBrick :title="`${t('totalUsers')}:`" :value="stats.delegates" icon="pi pi-users"
                     iconBg="bg-indigo-600" iconColor="text-white" cardBg="bg-white" valueClass="text-gray-900" />
                  <MoleculeStatBrick :title="`${t('totalProducts')}:`" :value="stats.products" icon="pi pi-box"
                     iconBg="bg-yellow-500" iconColor="text-white" cardBg="bg-white" valueClass="text-gray-900" />
                  <MoleculeStatBrick :title="`${t('totalAgencies')}:`" :value="stats.agencies" icon="pi pi-briefcase"
                     iconBg="bg-purple-600" iconColor="text-white" cardBg="bg-white" valueClass="text-gray-900" />
                  <MoleculeStatBrick :title="`${t('totalHealthCenters')}:`" :value="stats.institutions"
                     icon="pi pi-map-marker" iconBg="bg-green-600" iconColor="text-white" cardBg="bg-white"
                     valueClass="text-gray-900" />
               </div>
            </div>
         </div>
         <div v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.AGENCY_MANAGER"
            class="w-full grid md:grid-cols-2 lg:grid-cols-4 gap-1 sm:gap-3 justify-between items-center">
            <MoleculeStatBrick :title="`${t('agencyDelegates')}:`" :value="stats.delegates" icon="pi pi-users"
               iconBg="bg-indigo-600" iconColor="text-white" cardBg="bg-white" valueClass="text-gray-900" />
            <MoleculeStatBrick :title="`${t('agencyProducts')}:`" :value="stats.products" icon="pi pi-box"
               iconBg="bg-yellow-500" iconColor="text-white" cardBg="bg-white" valueClass="text-gray-900" />
            <MoleculeStatBrick :title="`${t('totalTeams')}:`" :value="stats.teams" icon="pi pi-briefcase"
               iconBg="bg-sky-500" iconColor="text-white" cardBg="bg-white" valueClass="text-gray-900" />
            <MoleculeStatBrick :title="`${t('totalSectors')}:`" :value="stats.sectors" icon="pi pi-map-marker"
               iconBg="bg-green-600" iconColor="text-white" cardBg="bg-white" valueClass="text-gray-900" />
         </div>
         <div class="mt-8" v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.AGENCY_MANAGER">
            <NuxtLink class="text-white bg-primary font-semibold border border-ody-blue rounded text-center p-4"
               :to="{ path: '/agencies/home', query: { agency_id: UserProfile()?.agencyId, country_id: UserProfile()?.countryId } }">
               {{ t("manageAgency") }} ->
            </NuxtLink>
         </div>

         <!-- stat -->
         <div class="mb-4 mt-10" v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN">
            <div class="bg-white rounded-lg shadow p-4">
               <div class="min-h-[200px]">
                  <MoleculeAgencyTargetsChart />
                  <div class="text-sm text-gray-500 text-right ">{{  'Last 30 days' }}</div>

               </div>
            </div>
         </div>

         <!-- Report AI Analyzer -->
         <div class="mb-4 mt-10" v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN">
            <MoleculeReportAiAnalyzer />
         </div>

         <div>
            <AtomSpinner v-if="loading" />

            <div
               v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.AGENCY_MANAGER || RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN">
               <div class="bg-white rounded-lg shadow p-4">
                  <div class="flex py-4 justify-between items-center">
                     <p class="pt-3 text-xl font-semi-bold leading-relaxed">
                        {{ t("agencyDelegatesStatistics") }}
                     </p>

                     <div
                        v-if="AgencyStat >= 0 && (RoleIndex(UserProfile()?.roles) === RoleCategory.AGENCY_MANAGER || RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN)"
                        class="flex flex-col items-center justify-center ml-6">
                        <div class="p-4 flex items-center justify-center rounded-full shadow-lg border-4"
                           :class="[AgencyStat > 70 ? 'border-green-500 bg-green-100' : 'border-red-500 bg-red-100']">
                           <span class="text-3xl font-bold"
                              :class="[AgencyStat > 70 ? 'text-green-700' : 'text-red-700']">
                              {{ AgencyStat }}%
                           </span>
                        </div>
                        <span class="mt-2 text-sm text-gray-600 font-medium">
                           {{ t('achievementRate') }}
                        </span>
                     </div>
                  </div>

                  <div class=" space-y-2">
                     <MoleculeFilterDeleguateActivityFilter @teamStat="setTeamStat" />
                  </div>

                  <!-- Histogram -->
                  <div v-if="TeamStat.length > 0" class="mb-6">
                     <MoleculeTeamObjectivesHistogram :teamStats="TeamStat" />
                  </div>

                  <!-- accordion start -->
                  <div class="grid grid-cols-2 gap-3 w-full" v-if="TeamStat.length > 0">
                     <OrganismStatDelegateActivityAccordeon v-for="(teamStat, index) in TeamStat" :key="index"
                        :index="index" :teamStat="teamStat" />
                  </div>
               </div>
            </div>
         </div>

         <div
            v-if="((RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN || RoleIndex(UserProfile()?.roles) === RoleCategory.CONTROLLER) && $config.public.moduleController)">
            <div class="bg-white rounded-lg shadow p-4 mt-10">
               <div class="flex py-4">
                  <p class="pt-3 text-xl font-semi-bold  leading-relaxed">Controller Statistics</p>

                  <!-- <div v-if="AgencyStat >= 0" class="w-20 h-20 flex justify-center items-center text-white font-extrabold text-[15px] rounded-full" :class="[AgencyStat > 70 ? 'bg-green-500' : 'bg-red-500']">{{ AgencyStat }} %</div> -->
               </div>

               <div class=" space-y-2">
                  <div>
                     <MoleculeFilterControllerActivityFilter @controllerStat="setControllerfilter" />
                  </div>

                  <!-- accordion start -->
                  <div class="grid grid-cols-2 gap-3 w-full">
                     <OrganismStatControllerActivityAccordeon v-for="(Stat, index) in ControllerStat" :key="index"
                        :index="index" :ControllerStat="Stat" />
                  </div>
               </div>
            </div>
         </div>

         <div v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.CONTROLLER">
            <div class="flex py-4 mt-10">
               <p class="pt-3 text-lg font-extrabold  leading-relaxed">Delegates Statistics</p>
            </div>

            <div class=" space-y-2">
               <div class="grid grid-cols-2 gap-3 w-full">
                  <OrganismStatDelegateActivityAccordeon v-for="(teamStat, index) in TeamStat" :key="index"
                     :index="index" :teamStat="teamStat" />
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import AgencyTargetsChart from '@/components/molecule/AgencyTargetsChart.vue';
import StatBrick from '@/components/molecule/stat/stat-brick.vue';
import ReportAiAnalyzer from '@/components/molecule/ReportAiAnalyzer.vue';
import TeamObjectivesHistogram from '@/components/molecule/TeamObjectivesHistogram.vue';


interface Stats {
   agencies: number | null;
   countries: number | null;
   delegates: number | null;
   institutions: number | null;
   products: number | null;
   teams: number | null;
   sectors: number | null;
}

interface TeamStat {
   team?: {
      teamStats?: {
         total?: {
            planned: number;
            achieved: number;
         };
      };
   };
}

interface ControllerStat {
   user: any;
   ratio: number;
}

export default defineComponent({
   name: "Base",
   components: {
      MoleculeAgencyTargetsChart: AgencyTargetsChart,
      MoleculeStatBrick: StatBrick,
      MoleculeReportAiAnalyzer: ReportAiAnalyzer,
      MoleculeTeamObjectivesHistogram: TeamObjectivesHistogram
   },
   data() {
      return {
         stats: {
            agencies: null,
            countries: null,
            delegates: null,
            institutions: null,
            products: null,
         } as Stats,
         statsT: {} as Record<string, any>,
         loading: false,
         TeamStat: [] as TeamStat[],
         AgencyStat: -1,
         ControllerStat: [] as ControllerStat[],
      };
   },
   setup() {
      definePageMeta({ title: "Dashboard", layout: "default", middleware: ["auth"] });
      useSeoMeta({
         title: "Dashboard",
      });
      const { t } = useI18n();
      return {
         t,
      };
   },
   mounted() {
      this.$nextTick(() => {
         this.getStat();

         
      });
   },
   methods: {
      setControllerfilter(filter: { startDate: { value: string }; endDate: { value: string }; country?: { value: string } }) {
         this.loading = true;
         if (RoleIndex(UserProfile()?.roles) === RoleCategory.CONTROLLER) {
            GetControllerStats(new Date(filter.startDate.value).toISOString().split('T')[0], new Date(filter.endDate.value).toISOString().split('T')[0])
               .then((res: number) => {
                  this.ControllerStat = [{ user: UserProfile(), ratio: res }];
               })
               .catch((error: any) => ErrorAlert(error))
               .finally(() => (this.loading = false));
            GetControllerTeamsStats(new Date(filter.startDate.value).toISOString().split('T')[0], new Date(filter.endDate.value).toISOString().split('T')[0] )
               .then((res: any[]) => {
                  this.TeamStat = res.map((e) => {
                     return {
                        team: e,
                     };
                  });
               })
               .catch((error: any) => ErrorAlert(error))
               .finally(() => (this.loading = false));
         } else {
            GetLabControllerStatByCountry(filter.country?.value as string, new Date(filter.startDate.value).toISOString().split('T')[0], new Date(filter.endDate.value).toISOString().split('T')[0] )
               .then((res: any) => {
                  this.ControllerStat = res;
               })
               .catch((error: any) => ErrorAlert(error))
               .finally(() => (this.loading = false));
         }
      },
      setTeamStat(data: TeamStat[]) {
         let planned = 0;
         let achieved = 0;

         this.TeamStat = data;
         data?.forEach((e) => {
            planned += e.team?.teamStats?.total?.planned || 0;
            achieved += e.team?.teamStats?.total?.achieved || 0;
         });
         this.AgencyStat = planned > 0 ? parseFloat((100 * (achieved / planned)).toFixed(2)) : 0;
      },
      getStat() {
         if (RoleIndex(UserProfile()?.roles) === RoleCategory.AGENCY_MANAGER) {
            this.loading = true;

            GetAgencyStats(UserProfile()?.agencyId)
               .then((res: Stats) => {
                  this.stats = res;
               })
               .catch((error: any) => {
                  ErrorAlert(error);
               })
               .finally(() => {
                  this.loading = false;
               });
         }
         if (RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN) {
            this.loading = true;

            GetDashStat()
               .then((res: Stats) => {
                  this.stats = res;
               })
               .catch((error: any) => {
                  ErrorAlert(error);
               })
               .finally(() => {
                  this.loading = false;
               });
         }
      },
   },
});
</script>
<style scoped></style>
